import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

const ProductObservationsPage = lazy(() =>
  import('./pages/ProductObservationsPage').then((module) => ({
    default: module.ProductObservationsPage,
  })),
);

const WarehouseProductObservationsPage = lazy(() =>
  import('./pages/WarehouseProductObservationsPage').then((module) => ({
    default: module.WarehouseProductObservationsPage,
  })),
);

const ProductObservationDetailPage = lazy(() =>
  import('./pages/ProductObservationDetailPage').then((module) => ({
    default: module.ProductObservationDetailPage,
  })),
);

export const productObservationsRoutes: RouteObject[] = [
  {
    path: 'productos-observados',
    element: createElement(ProtectedRoute),
    children: [
      { index: true, element: createElement(ProductObservationsPage) },
      { path: 'almacen', element: createElement(WarehouseProductObservationsPage) },
      { path: ':id', element: createElement(ProductObservationDetailPage) },
    ],
  },
];
